var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0378 0H0C0 5.86 2.13182 11.2252 5.6703 15.3741L6.41726 13.7632C6.96012 12.5924 6.96012 11.2448 6.41726 10.0738L3.23133 3.2061L10.1576 6.36496C11.3384 6.90325 12.6974 6.90325 13.8802 6.36496L20.8045 3.2061L17.6208 10.074C17.0759 11.2448 17.0759 12.5924 17.6208 13.7635L20.8045 20.6314L13.8802 17.4725C12.6974 16.9342 11.3384 16.9342 10.1576 17.4725L8.53305 18.2132C12.7172 21.7219 18.13 23.8355 24.0378 23.8355V0Z",
    fill: "#FF6C22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30187 21.4174L0.000152588 23.8356L2.4389 18.5785C2.8747 19.0912 3.33231 19.5843 3.80996 20.0579C4.28738 20.5313 4.78461 20.985 5.30187 21.4174Z",
    fill: "#FF6C22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/mobile-logo.0741ae627bdbda3e0c16e57bb687a3e9.svg";
export { ForwardRef as ReactComponent };